import * as React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import { Text } from "../Text/Text";

import Styles from "./TabNavBarItem.module.scss";

export interface TabNavBarItemProps {
  label: string;
  path: string;
  active: boolean;
  isEvent: boolean;
  ["data-testid"]?: string;
}

export const TabNavBarItem = (props: TabNavBarItemProps) => {
  const linkRef = React.useRef<HTMLAnchorElement>(null);

  // The tab row scrolls horizontally on phones with the scrollbar hidden, so the
  // active tab can land offscreen; keep it visible. block: "nearest" avoids
  // scrolling the page vertically.
  React.useEffect(() => {
    if (props.active) {
      linkRef.current?.scrollIntoView({ block: "nearest", inline: "nearest" });
    }
  }, [props.active]);

  let textColor = "";
  let fontWeight = "";
  if (props.isEvent) {
    textColor = props.active ? "gc-blue" : "cool-grey-dark";
    fontWeight = props.active ? "bold" : "semibold";
  } else {
    textColor = props.active ? "gc-blue" : "cool-grey-dark";
    fontWeight = props.active ? "bold" : "semibold";
  }
  const tabNavBarItemClassNames = cn(Styles.tabNavBarItem, props.isEvent ? "" : Styles.tabItem, {
    [Styles.activeTabNavBarItem]: props.active,
  });

  return (
    <Link ref={linkRef} to={props.path} data-testid={props["data-testid"]}>
      <div className={tabNavBarItemClassNames} role="tab">
        <Text className={Styles.tabNavBarLabel} color={textColor} weight={fontWeight}>
          {props.label}
        </Text>
      </div>
      <div className={cn({ [Styles.activeTabItemUnderline]: props.active }, Styles[textColor])} />
    </Link>
  );
};
